@if (!newRow) {
	<button
		class="btn btn-icon"
		titleLang="add"
		(click)="prepNewRow()"
		icon="plus"
	></button>
}
<div>
	@if (newRow) {
		<div class="d-flex  new-row" style="border-bottom: 1px solid var(--grey);">
			<div class="colstat colstat-small">
				<label>
					{{ "name" | langVal }}
				</label>
				<app-gen-input
					[actualObj]="newRow"
					fieldName="name"
				/>
			</div>
			<div class="colstat colstat-small-triple">
				<label>
					{{ "pending_text" | langVal }}
				</label>
				<app-ta-expands
					[actualObj]="newRow"
					fieldName="pending_text"
				/>
			</div>
			<div class="colstat colstat-price"></div>

			<div>
				<app-btn-ext
					(click)="saveNewRow()"
					[isSpin]="newRow.isSaving"
					[disabled]="!newRow.name || !newRow.pending_text"
					text="save"
				/>
			</div>
			<div>
				<button
					class="btn btn-icon"
					(click)="newRow = null"
					icon="delete"
				></button>
			</div>
		</div>
	}
	@for (row of rows; track row.id) {
		<div class="d-flex" style="border-bottom: 1px solid var(--grey);">
			<div class="colstat colstat-small">
				<label>
					{{ "name" | langVal }}
				</label>
				<app-gen-input
					[actualObj]="row"
					fieldName="name"
					(changeEvent)="updateName(row)"
				/>
			</div>
			<div class="colstat colstat-small-triple">
				<label>
					{{ "current_text" | langVal }}
				</label>
				<div [innerHTML]="row.current_text | safeHtml"></div>
				@if (row.updateIsOpen) {
					<div>
						<div class="colstat-small-triple">
							<label>
								{{ "pending_text" | langVal }}
							</label>
							<app-ta-expands
								[actualObj]="row"
								fieldName="pending_text"
							/>
						</div>
						<div>
							<app-btn-ext
								(click)="updateText(row)"
								[isSpin]="row.isSaving"
								[disabled]="!row.name || !row.pending_text"
								text="save"
							/>
						</div>
					</div>
				} @else {
					<div>
						<app-btn-ext
							(click)="openUpdate(row)"
							text="open_update"
						/>
					</div>
				}
			</div>
			<div class="colstat colstat-price">
				<label>
					{{ "status" | langVal }}
				</label>
				<p>
					{{ row.status | langVal }}
				</p>
			</div>

			<div>
				<button
					class="btn btn-icon"
					(click)="deleteRow(row)"
					icon="delete"
				></button>
			</div>
		</div>
	}
</div>
